function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "fansi class",
  transform: "translate(-418.034 -132.89)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 531",
  fill: "none",
  stroke: "#eae9ee",
  strokeWidth: 3,
  d: "M867.392 132.89v389.453"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 532",
  fill: "none",
  stroke: "#eae9ee",
  strokeWidth: 3,
  d: "M1005.501 290.294L897.33 528.642"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 533",
  fill: "none",
  stroke: "#eae9ee",
  strokeWidth: 3,
  d: "M1273.828 224.46L922.195 546.462"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 534",
  fill: "none",
  stroke: "#eae9ee",
  strokeWidth: 3,
  d: "M418.96 243.39l390.58 306.627"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 535",
  fill: "none",
  stroke: "#eae9ee",
  strokeWidth: 3,
  d: "M654.158 184.816l179.07 345.848"
}), /*#__PURE__*/React.createElement("rect", {
  "data-name": "Rectangle 20406",
  width: 246.785,
  height: 164.059,
  rx: 1.93,
  transform: "translate(743.995 440.313)",
  fill: "#bbe4e0"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 358304",
  d: "M882.809 522.342a15.416 15.416 0 11-15.416-15.416 15.416 15.416 0 0115.416 15.416z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 20407",
  fill: "#eae9ee",
  d: "M632.923 577.186h468.929v38.93H632.923z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 20408",
  fill: "#eae9ee",
  d: "M666.881 612.785h20.257v199.608h-20.257z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 20409",
  fill: "#eae9ee",
  d: "M666.881 612.785h20.257v6.656h-20.257z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 20410",
  fill: "#eae9ee",
  d: "M1063.088 612.785h20.257v199.608h-20.257z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 20411",
  fill: "#eae9ee",
  d: "M1063.088 612.785h20.257v6.656h-20.257z"
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 6720",
  cx: 42.188,
  cy: 42.188,
  r: 42.188,
  transform: "translate(455.777 260.174)",
  fill: "#796eaf"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 358305",
  d: "M483.493 286.714v34.189a3.581 3.581 0 005.338 3.125l30.368-17.1a3.581 3.581 0 000-6.241l-30.368-17.1a3.581 3.581 0 00-5.338 3.125z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 358306",
  d: "M735.923 239.315v16.908a23.207 23.207 0 01-23.207 23.207h-47.294l-10.874 10.866v-11.854a23.207 23.207 0 01-16.519-22.221v-16.906a23.207 23.207 0 0123.207-23.207h51.487a23.207 23.207 0 0123.2 23.207z",
  fill: "#e7718b"
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 6721",
  cx: 6.059,
  cy: 6.059,
  r: 6.059,
  transform: "translate(662.869 243.398)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 6722",
  cx: 6.059,
  cy: 6.059,
  r: 6.059,
  transform: "translate(680.913 243.398)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 6723",
  cx: 6.059,
  cy: 6.059,
  r: 6.059,
  transform: "translate(698.957 243.398)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 358307",
  d: "M1016.73 272.664c-7.41 0-12.167 4.849-14.662 9.2-2.486-4.351-7.244-9.2-14.654-9.2a16.361 16.361 0 00-16.577 16.751c0 10.352 9.034 17.406 22.519 28.081 6.631 5.222 7.037 5.619 8.744 7 1.4-1.127 2.172-1.8 8.744-7 13.493-10.675 22.528-17.729 22.528-28.081a16.361 16.361 0 00-16.643-16.751z",
  fill: "#e7718b"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 358308",
  d: "M1237.293 239.785c-12.383 0-20.348 8.106-24.509 15.391-4.144-7.285-12.126-15.391-24.517-15.391-15.748 0-27.782 12.043-27.782 28.015 0 17.314 15.11 29.109 37.671 46.962 11.048 8.736 11.761 9.4 14.629 11.7 2.337-1.881 3.63-3.009 14.621-11.7 22.561-17.853 37.671-29.647 37.671-46.962-.001-15.975-12.061-28.015-27.784-28.015z",
  fill: "#e7718b"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 18002"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 358309",
  d: "M1069.429 201.451c-18.234 0-29.954 11.935-36.088 22.66-6.133-10.725-17.853-22.66-36.087-22.66-23.141 0-40.895 17.729-40.895 41.243 0 25.487 22.238 42.851 55.449 69.133 16.27 12.855 17.314 13.833 21.55 17.231 3.44-2.768 5.346-4.443 21.55-17.231 33.211-26.282 55.457-43.646 55.457-69.133-.046-23.514-17.795-41.243-40.936-41.243z",
  fill: "none",
  stroke: "#e7718b",
  strokeWidth: 3,
  opacity: 0.21
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 358310",
  d: "M906.19 253.933c.116.829.2 1.658.257 2.428a40.091 40.091 0 01-63.87 35.292c-.406-.3-.829-.605-1.2-.928l-.663-.539a226.273 226.273 0 0065.478-36.253z",
  fill: "#9082c0"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 358311",
  d: "M892.812 229.176l.257.2c.531.423 1.044.829 1.55 1.31 16.577-5.28 28.073-5.454 30.543-.945 2.055 3.771-1.882 10.866-10.816 19.469q-3.042 2.917-6.631 5.926a226.535 226.535 0 01-65.478 36.253c-17.687 5.926-30.012 6.3-32.581 1.608-1.5-2.735.166-7.244 4.633-12.805a72.468 72.468 0 016.175-6.631 114.743 114.743 0 017.874-6.912c-.116-.829-.216-1.6-.282-2.4-3.315 2.644-6.341 5.263-9.01 7.841-12.557 12.084-13.021 18.6-11.2 21.931 3.655 6.631 18.458 5.023 36.253-1.127a218.148 218.148 0 0032.552-14.627 212.4 212.4 0 0031.321-20.671c2.851-2.312 5.47-4.617 7.816-6.879a74.455 74.455 0 006.407-6.9c6.241-7.783 6.224-12.433 4.791-15.035-3.535-6.428-17.323-5.168-34.174.394z",
  fill: "#736b99",
  stroke: "#736b99",
  strokeWidth: 5
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 358312",
  d: "M891.578 228.173c.522.423 1.044.829 1.542 1.31a39.909 39.909 0 0113.071 24.451 226.273 226.273 0 01-65.478 36.253 39.909 39.909 0 01-13.891-24.774c-.124-.829-.224-1.6-.29-2.4a40.1 40.1 0 0164.781-35.035z",
  fill: "#9082c0"
}));

function SvgFansiClass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 856.807 679.503",
    className: "w-full h-full"
  }, props), _ref);
}

export default SvgFansiClass;